import React from 'react'

const Spacer = () => <div style={{ paddingTop: '20px' }} />

export default Spacer
